export const articles = [
  {
    id: 'article-1',
    slug: 'dingri-moumou-shuijiao-men',
    title: '顶流男星深夜密会神秘女子，酒店共处8小时',
    excerpt: '据知情人士爆料，某当红顶流男星近日被拍到深夜与一名神秘女子共同进入某五星级酒店，直到次日清晨才离开。事件曝光后引发网友热议，粉丝纷纷要求工作室给出解释。',
    content: `<p>据知情人士透露，某当红顶流男星（以下简称A某）近日被拍到深夜与一名神秘女子共同进入北京某五星级酒店。据目击者称，两人于当晚11点左右先后进入酒店，直到次日清晨7点才相继离开。</p>
<h2>事件经过</h2>
<p>据现场目击者描述，A某当晚身穿黑色卫衣、戴着口罩和帽子，刻意低调行事。神秘女子则身穿白色连衣裙，两人在酒店大堂并未有亲密举动，但先后进入了同一部电梯。</p>
<p>酒店工作人员透露，A某在该酒店长期包有一间总统套房，此次神秘女子进入的正是该楼层。</p>
<h2>网友反应</h2>
<p>消息一经传出，立刻在微博引发热议。话题#顶流男星深夜密会#迅速登上热搜榜首，阅读量突破3亿。不少网友表示"塌房了"，也有粉丝坚称"只是普通朋友聚会"。</p>
<h2>工作室回应</h2>
<p>截至目前，A某工作室尚未对此事做出正式回应。但据内部人士透露，工作室正在紧急商讨公关方案。</p>`,
    category: 'mingxing-fanche',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20scandal%20night%20scene%20luxury%20hotel%20entrance%20with%20paparazzi%20style%20lighting%2C%20dramatic%20moody%20atmosphere%2C%20dark%20tones%2C%20cinematic%20photography%2C%20blurred%20figures%20entering%20hotel%2C%20mysterious%20vibe%2C%20nighttime%20urban%20setting%2C%20film%20grain%20texture&width=800&height=500&seq=article-1-main&orientation=landscape',
    author: '吃瓜前线记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Professional%20reporter%20portrait%20avatar%2C%20neutral%20expression%2C%20clean%20simple%20background%2C%20warm%20lighting&width=100&height=100&seq=author-1&orientation=squarish',
    date: '2026-07-06',
    views: 128500,
    hotScore: 98,
    tags: ['顶流', '酒店密会', '塌房', '粉丝热议'],
  },
  {
    id: 'article-2',
    slug: 'wanghong-daihuo-jiahuo',
    title: '千万网红直播带货翻车，被曝售卖假冒伪劣产品',
    excerpt: '拥有2000万粉丝的知名带货网红近日被消费者集体举报，称其直播间销售的多款化妆品为假冒伪劣产品。市场监管部门已介入调查，该网红所有直播活动已被暂停。',
    content: `<p>近日，拥有超过2000万粉丝的知名带货网红"XX姐"遭遇职业生涯最大危机。多名消费者联合举报，称在其直播间购买的多个品牌化妆品经鉴定为假冒伪劣产品。</p>
<h2>事件起因</h2>
<p>最早是一位消费者在社交平台发文，称在XX姐直播间购买的面膜使用后出现严重过敏反应。随后，越来越多消费者站出来表示遭遇类似情况。</p>
<h2>鉴定结果</h2>
<p>经第三方权威机构鉴定，涉事产品中的多个批次确实存在成分不符、包装印刷粗糙等问题，被认定为假冒产品。涉及品牌包括多个知名国际护肤品牌。</p>
<h2>官方介入</h2>
<p>目前，当地市场监督管理局已正式立案调查。XX姐的所有直播活动已被平台方暂停，其社交账号也处于禁言状态。</p>`,
    category: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Livestreaming%20studio%20with%20beauty%20products%20scattered%20on%20table%2C%20dramatic%20lighting%2C%20controversy%20atmosphere%2C%20professional%20photography%2C%20warm%20studio%20lights%2C%20makeup%20products%20closeup%2C%20tense%20mood&width=800&height=500&seq=article-2-main&orientation=landscape',
    author: '消费维权观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Investigative%20journalist%20portrait%20avatar%2C%20serious%20expression%2C%20simple%20background%2C%20professional%20look&width=100&height=100&seq=author-2&orientation=squarish',
    date: '2026-07-05',
    views: 256800,
    hotScore: 95,
    tags: ['带货翻车', '假货', '网红', '消费者维权'],
  },
  {
    id: 'article-3',
    slug: 'keji-gongsi-caiyuan',
    title: '知名科技公司大规模裁员，内部邮件曝光引发震荡',
    excerpt: '某头部科技公司突然宣布大规模裁员计划，涉及员工超3000人。一份内部邮件被曝光，揭示了裁员背后不为人知的真相，包括高管奖金照发、普通员工零补偿等内幕。',
    content: `<p>本周一，某头部科技公司突然向全体员工发送了一封裁员通知邮件，宣布将进行大规模组织架构调整，预计裁员人数超过3000人，占公司总人数的15%。</p>
<h2>裁员细节</h2>
<p>根据曝光的内部邮件显示，此次裁员主要涉及中层管理岗位和部分技术团队。邮件中提到"这是为了提升公司运营效率的必要举措"。</p>
<h2>争议焦点</h2>
<p>然而，另一封泄露的内部会议纪要显示，公司高管团队在裁员决策会议中明确表示"高管奖金不受影响"，而普通被裁员工仅能获得法定最低补偿。</p>
<h2>员工反应</h2>
<p>消息传出后，公司内部论坛瞬间炸锅。多位员工匿名发帖表达不满，称"高管拿巨额奖金，底层员工被扫地出门"。部分员工已开始组织维权行动。</p>`,
    category: 'qiye-neimu',
    image: 'https://readdy.ai/api/search-image?query=Modern%20corporate%20office%20building%20exterior%20at%20dusk%2C%20dramatic%20clouds%2C%20employees%20leaving%20with%20boxes%2C%20moody%20atmosphere%2C%20corporate%20drama%2C%20glass%20building%20reflection%2C%20urban%20setting&width=800&height=500&seq=article-3-main&orientation=landscape',
    author: '财经内幕调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Business%20investigator%20portrait%20avatar%2C%20professional%20demeanor%2C%20clean%20background%2C%20sharp%20look&width=100&height=100&seq=author-3&orientation=squarish',
    date: '2026-07-04',
    views: 189200,
    hotScore: 88,
    tags: ['裁员', '科技公司', '内幕曝光', '员工维权'],
  },
  {
    id: 'article-4',
    slug: 'nvyoutuan-neihong',
    title: '女团成员爆内讧！台上亲密台下互撕，录音曝光',
    excerpt: '某当红女团被曝成员之间存在严重矛盾。一段私下争吵的录音在网络上疯传，录音中两位成员互相指责对方"抢资源""背后搞小动作"，女团形象一夜崩塌。',
    content: `<p>娱乐圈再爆猛料！某当红女团被曝内部矛盾严重，一段长达15分钟的私下争吵录音近日在网络上疯传，引发轩然大波。</p>
<h2>录音内容</h2>
<p>录音中可以清晰听到两位成员的激烈争吵。其中一人指责对方"每次都抢我的part""在经纪人面前说我坏话"，另一人则反击称"你才是背后搞小动作的人""资源是自己争取的"。</p>
<h2>粉丝分裂</h2>
<p>录音曝光后，该女团的粉丝群迅速分裂为两派。双方粉丝在社交平台上互相攻击，场面一度失控。话题#XX女团内讧#在微博热搜榜停留超过48小时。</p>
<h2>经纪公司声明</h2>
<p>经纪公司随后发表声明，称录音系"恶意剪辑"，并表示将追究法律责任。但这一声明并未平息舆论，反而引发更多质疑。</p>`,
    category: 'mingxing-fanche',
    image: 'https://readdy.ai/api/search-image?query=K-pop%20girl%20group%20performance%20stage%20dramatic%20lighting%2C%20tension%20between%20members%2C%20split%20composition%2C%20glamorous%20outfits%2C%20behind%20scenes%20drama%2C%20professional%20stage%20photography&width=800&height=500&seq=article-4-main&orientation=landscape',
    author: '娱乐圈深喉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Entertainment%20journalist%20portrait%20avatar%2C%20stylish%20look%2C%20simple%20background%2C%20trendy%20appearance&width=100&height=100&seq=author-4&orientation=squarish',
    date: '2026-07-03',
    views: 312000,
    hotScore: 92,
    tags: ['女团', '内讧', '录音曝光', '粉丝大战'],
  },
  {
    id: 'article-5',
    slug: 'shipin-pingtai-shuju-zaojia',
    title: '视频平台数据造假被实锤！员工曝内部刷量流程',
    excerpt: '某知名短视频平台被前员工实名举报存在系统性数据造假行为。举报人提供了详细的内部操作手册和截图，揭示了平台如何通过技术手段虚增播放量、点赞数和粉丝数。',
    content: `<p>一场由前员工发起的实名举报，揭开了短视频行业数据造假的冰山一角。某知名短视频平台前技术员工近日向媒体提供了大量内部证据，证明该平台存在系统性的数据造假行为。</p>
<h2>造假手段</h2>
<p>根据举报人提供的内部文档，平台使用了多种技术手段虚增数据。包括但不限于：僵尸账号自动播放、批量刷量脚本、播放量倍数放大算法等。一份内部邮件甚至显示，高管明确指示"头部主播的数据至少要翻3倍"。</p>
<h2>行业影响</h2>
<p>此消息一出，整个短视频行业为之震动。多位广告主表示将重新评估在该平台的投放策略。业内专家指出，如果指控属实，这将是国内互联网行业最大规模的数据造假丑闻之一。</p>`,
    category: 'qiye-neimu',
    image: 'https://readdy.ai/api/search-image?query=Digital%20data%20analytics%20dashboard%20with%20manipulated%20numbers%2C%20dark%20tech%20office%2C%20multiple%20screens%2C%20cyber%20atmosphere%2C%20coding%20scenes%2C%20mysterious%20tech%20vibe%2C%20blue%20monitor%20glow&width=800&height=500&seq=article-5-main&orientation=landscape',
    author: '科技调查记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Tech%20investigative%20reporter%20portrait%20avatar%2C%20analytical%20look%2C%20simple%20background&width=100&height=100&seq=author-5&orientation=squarish',
    date: '2026-07-02',
    views: 275600,
    hotScore: 90,
    tags: ['数据造假', '短视频', '实名举报', '行业黑幕'],
  },
  {
    id: 'article-6',
    slug: 'daV-fuhao-jiabao',
    title: '大V被曝家暴前妻，聊天记录与伤情鉴定流出',
    excerpt: '拥有500万粉丝的知名博主被前妻实名举报家暴。前妻公开了多张伤情鉴定报告和数十页的聊天记录，详细记录长达三年的家暴过程，证据触目惊心。',
    content: `<p>一场家庭悲剧正在互联网上引发广泛关注。拥有500万粉丝的知名博主"XX老师"被前妻实名举报存在长期家暴行为。</p>
<h2>证据链完整</h2>
<p>前妻在社交媒体上公开了时间跨度长达三年的证据。其中包括：多份医院伤情鉴定报告（显示肋骨骨折、软组织挫伤等）、数十页微信聊天记录（包含威胁、辱骂和道歉内容）、以及多段录音录像。</p>
<h2>当事人回应</h2>
<p>面对铁证，该博主最初发布声明称"这是恶意诽谤"，但随后又删除了该声明。其社交账号的评论区已被网友的声讨淹没。</p>
<h2>法律进展</h2>
<p>据悉，前妻已委托律师向法院提起诉讼。当地妇联也介入此事，表示将提供法律援助。</p>`,
    category: 'heiliao-baoguang',
    image: 'https://readdy.ai/api/search-image?query=Dark%20moody%20interior%20scene%20with%20documents%20and%20evidence%20on%20table%2C%20dramatic%20shadows%2C%20legal%20documents%2C%20tense%20atmosphere%2C%20film%20noir%20style%2C%20investigation%20theme&width=800&height=500&seq=article-6-main&orientation=landscape',
    author: '社会新闻调查组',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Social%20news%20journalist%20portrait%20avatar%2C%20empathetic%20expression%2C%20simple%20background&width=100&height=100&seq=author-6&orientation=squarish',
    date: '2026-07-01',
    views: 452100,
    hotScore: 96,
    tags: ['家暴', '大V', '实名举报', '社会关注'],
  },
  {
    id: 'article-7',
    slug: 'yinyuejie-zuobi-men',
    title: '音乐榜单被曝刷榜黑幕，多家唱片公司牵涉其中',
    excerpt: '音乐排行榜被曝存在大规模刷榜行为。调查发现，多家唱片公司通过专业刷榜团队操纵各大音乐平台排行榜，涉及金额高达数千万元。多位知名歌手的排名疑似造假。',
    content: `<p>音乐圈再爆惊天黑幕！一项长达半年的调查揭示，国内多家主流音乐平台的排行榜存在大规模人为操纵行为。</p>
<h2>刷榜产业链</h2>
<p>调查发现，市场上已形成完整的刷榜产业链。专业团队通过控制成千上万台设备，利用自动化脚本24小时不间断播放特定歌曲。收费从数万元到数百万元不等，根据排名位置定价。</p>
<h2>牵涉范围</h2>
<p>据不完全统计，至少有15家唱片公司和超过50位知名歌手牵涉其中。某选秀出身的歌手被曝花费1200万元购买了连续三个月的榜首位置。</p>`,
    category: 'heiliao-baoguang',
    image: 'https://readdy.ai/api/search-image?query=Music%20chart%20ranking%20display%20with%20manipulated%20numbers%2C%20dramatic%20studio%20lighting%2C%20music%20industry%20scene%2C%20recording%20studio%20background%2C%20golden%20and%20dark%20tones&width=800&height=500&seq=article-7-main&orientation=landscape',
    author: '音乐圈观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Music%20industry%20analyst%20portrait%20avatar%2C%20stylish%2C%20simple%20background&width=100&height=100&seq=author-7&orientation=squarish',
    date: '2026-06-30',
    views: 198400,
    hotScore: 85,
    tags: ['刷榜', '音乐榜单', '唱片公司', '行业黑幕'],
  },
  {
    id: 'article-8',
    slug: 'wangluo-zhubo-taoshui',
    title: '网络主播被曝偷税漏税，金额惊人高达八千万元',
    excerpt: '税务部门通报，某头部网络主播因涉嫌偷逃税款被立案调查。初步查明，该主播通过设立个人独资企业、虚假申报等方式，累计偷逃税款超过8000万元。',
    content: `<p>税务部门近日通报了一起重大税务违法案件。某头部网络主播因涉嫌偷逃巨额税款被正式立案调查，涉案金额之大令人震惊。</p>
<h2>偷税手法</h2>
<p>根据税务部门的通报，该主播主要通过以下方式偷逃税款：将个人直播收入转化为企业收入、通过多个个人独资企业分散收入以适用较低的核定征收税率、虚假申报部分收入等。</p>
<h2>行业整顿</h2>
<p>此案引发了整个直播行业的税务自查风暴。据悉，已有超过100名头部主播主动联系税务部门进行自查补税。业内预计，整个行业补税金额可能超过50亿元。</p>`,
    category: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20lifestyle%20scene%20with%20tax%20documents%20and%20money%2C%20dramatic%20contrast%2C%20wealth%20display%2C%20golden%20lighting%2C%20investigation%20theme%2C%20financial%20scandal%20mood&width=800&height=500&seq=article-8-main&orientation=landscape',
    author: '财经调查记者',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Financial%20reporter%20portrait%20avatar%2C%20sharp%20professional%20look%2C%20simple%20background&width=100&height=100&seq=author-8&orientation=squarish',
    date: '2026-06-29',
    views: 386700,
    hotScore: 93,
    tags: ['偷税漏税', '网络主播', '税务', '行业整顿'],
  },
  {
    id: 'article-9',
    slug: 'wenyu-jijie-fenshou',
    title: '顶流CP被曝已秘密分手，双方团队互泼脏水',
    excerpt: '曾被粉丝称为"神仙眷侣"的顶流明星情侣被曝已在三个月前秘密分手。分手后双方团队互发通稿抹黑对方，一场娱乐圈的"脏水大战"正在上演。',
    content: `<p>娱乐圈最令人羡慕的一对"顶流CP"如今成了最大的笑话。多方消息证实，这对被粉丝称为"神仙眷侣"的明星情侣已于三个月前秘密分手。</p>
<h2>分手内幕</h2>
<p>据知情人士透露，分手原因与经济利益分配有关。两人合体代言的品牌合同到期后，双方在续约条件上产生严重分歧，最终导致感情破裂。</p>
<h2>团队互撕</h2>
<p>分手后，双方团队的公关战迅速升级。一方发布通稿暗示对方"出轨"，另一方则回击称对方"贪得无厌"。双方粉丝也加入了这场网络混战。</p>`,
    category: 'mingxing-fanche',
    image: 'https://readdy.ai/api/search-image?query=Celebrity%20couple%20split%20dramatic%20scene%2C%20two%20people%20walking%20opposite%20directions%2C%20rainy%20night%2C%20cinematic%20lighting%2C%20emotional%20separation%2C%20film%20noir%20style&width=800&height=500&seq=article-9-main&orientation=landscape',
    author: '娱乐圈深喉',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Entertainment%20gossip%20reporter%20portrait%20avatar%2C%20stylish%2C%20simple%20background&width=100&height=100&seq=author-9&orientation=squarish',
    date: '2026-06-28',
    views: 520300,
    hotScore: 99,
    tags: ['顶流CP', '分手', '公关大战', '娱乐圈'],
  },
  {
    id: 'article-10',
    slug: 'dianshang-pingtai-jiage-qizha',
    title: '电商平台被曝大数据杀熟，老用户价格比新用户贵30%',
    excerpt: '消费者协会发布调查报告，证实多家主流电商平台存在"大数据杀熟"行为。调查显示，同一商品老用户看到的价格比新用户平均高出30%，部分商品差价甚至翻倍。',
    content: `<p>消费者协会最新发布的调查报告揭开了电商行业的一个公开秘密——"大数据杀熟"现象确实存在，且比想象中更加普遍。</p>
<h2>调查结果</h2>
<p>消协对10家主流电商平台进行了为期三个月的调查，结果显示：8家平台存在不同程度的"杀熟"行为。老用户（注册超过一年）看到的价格比新注册用户平均高出30%，其中酒店预订类商品差价最为明显，最高可达100%。</p>
<h2>平台回应</h2>
<p>面对铁证，多家平台发表声明称价格差异是由于"个性化优惠券发放策略"导致的，并非故意"杀熟"。但这一说法并未获得消费者认可。</p>`,
    category: 'qiye-neimu',
    image: 'https://readdy.ai/api/search-image?query=E-commerce%20shopping%20cart%20with%20different%20prices%20displayed%2C%20digital%20comparison%2C%20consumer%20theme%2C%20clean%20tech%20aesthetic%2C%20price%20tags%2C%20modern%20shopping%20scene&width=800&height=500&seq=article-10-main&orientation=landscape',
    author: '消费维权观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Consumer%20rights%20advocate%20portrait%20avatar%2C%20determined%20expression%2C%20simple%20background&width=100&height=100&seq=author-10&orientation=squarish',
    date: '2026-06-27',
    views: 234500,
    hotScore: 87,
    tags: ['大数据杀熟', '电商', '消费者权益', '价格歧视'],
  },
  {
    id: 'article-11',
    slug: 'shipin-bozhu-chaoxi',
    title: '百万粉丝视频博主被扒抄袭，70%内容涉嫌搬运',
    excerpt: '一位拥有300万粉丝的视频博主被网友扒出大量抄袭行为。经过逐一比对，该博主发布的视频中约70%的内容涉嫌直接搬运或洗稿国外创作者的作品。',
    content: `<p>内容创作圈的抄袭风波再次升级。一位拥有300万粉丝的知名视频博主被网友系统性地扒出涉嫌大量抄袭国外创作者的作品。</p>
<h2>抄袭证据</h2>
<p>热心网友制作了详细的对比视频，将该博主的作品与原作逐帧对比。结果显示，不仅选题和脚本高度雷同，甚至连镜头语言、转场方式和文案措辞都几乎一模一样，仅将英文替换为中文。</p>
<h2>博主道歉</h2>
<p>在证据面前，该博主发布道歉声明，承认"在创作过程中参考了国外创作者的作品"，但否认"抄袭"指控，称其属于"二次创作"。这一说法引发更大争议。</p>`,
    category: 'wanghong-tafang',
    image: 'https://readdy.ai/api/search-image?query=Video%20editing%20studio%20with%20side-by-side%20comparison%20screens%2C%20plagiarism%20theme%2C%20creative%20workspace%2C%20dramatic%20lighting%2C%20content%20creation%20scene&width=800&height=500&seq=article-11-main&orientation=landscape',
    author: '内容创作观察站',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Content%20creator%20portrait%20avatar%2C%20creative%20look%2C%20simple%20background&width=100&height=100&seq=author-11&orientation=squarish',
    date: '2026-06-26',
    views: 167800,
    hotScore: 82,
    tags: ['抄袭', '视频博主', '搬运', '原创争议'],
  },
  {
    id: 'article-12',
    slug: 'shishang-pinpai-wenshi',
    title: '国际时尚品牌被曝歧视中国消费者，网友发起抵制',
    excerpt: '某国际知名时尚品牌海外官网被曝将中国地区单独标注为"不享受全球联保"，且同一产品中国售价高出海外40%。网友发起大规模抵制行动，品牌方紧急公关。',
    content: `<p>又一家国际品牌因涉嫌歧视中国消费者而陷入公关危机。某国际知名时尚品牌被消费者发现在售后服务政策中对中国市场区别对待。</p>
<h2>区别对待</h2>
<p>根据网友曝光的截图，该品牌海外官网的服务条款中，中国地区被单独标注为"不享受全球联保服务"。同时，同款产品在中国的售价平均比欧美市场高出40%。</p>
<h2>抵制行动</h2>
<p>消息传出后，#XX品牌歧视中国消费者#迅速登上热搜。大量网友表示将抵制该品牌，部分电商平台也出现了大规模退货潮。品牌官方旗舰店的评分一夜之间从4.8降至2.1。</p>`,
    category: 'qiye-neimu',
    image: 'https://readdy.ai/api/search-image?query=Luxury%20fashion%20store%20exterior%20with%20protest%20theme%2C%20dramatic%20lighting%2C%20consumer%20rights%2C%20high-end%20shopping%20street%2C%20tension%20atmosphere&width=800&height=500&seq=article-12-main&orientation=landscape',
    author: '消费维权观察员',
    authorAvatar: 'https://readdy.ai/api/search-image?query=Consumer%20investigator%20portrait%20avatar%2C%20serious%20look%2C%20simple%20background&width=100&height=100&seq=author-12&orientation=squarish',
    date: '2026-06-25',
    views: 298100,
    hotScore: 89,
    tags: ['品牌歧视', '抵制', '消费者权益', '双标'],
  },
];

export type Article = typeof articles[0];